var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0H2.25C1.005 0 0 1.005 0 2.25V9.75C0 10.995 1.005 12 2.25 12H9.75C10.995 12 12 10.995 12 9.75V2.25C12 1.005 10.995 0 9.75 0ZM8.25 7.6875C8.25 7.9125 8.115 8.1225 7.905 8.205C7.8375 8.235 7.7625 8.25 7.6875 8.25C7.545 8.25 7.395 8.19 7.29 8.085L4.875 5.67V7.6875C4.875 7.995 4.62 8.25 4.3125 8.25C4.005 8.25 3.75 7.995 3.75 7.6875V4.3125C3.75 4.0875 3.885 3.8775 4.095 3.795C4.305 3.705 4.545 3.7575 4.71 3.915L7.125 6.33V4.3125C7.125 4.005 7.38 3.75 7.6875 3.75C7.995 3.75 8.25 4.005 8.25 4.3125V7.6875Z",
    fill: "#FF607C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNew);
export default __webpack_public_path__ + "static/media/badge-new.3eb2be0db4ec1529fe66613c613266b4.svg";
export { ForwardRef as ReactComponent };